import React from 'react'
import cx from 'classnames'
import Image from './contentParticles/image'

class Intro extends React.Component {
  render() {
    const { intro, theme } = this.props

    if (!intro) {
      return null
    }

    return (
      <section data-label="intro" className="pt-32 md:pt-65 md:pb-75">
        <div className="container px-25">
          <p
            data-label="intro-text"
            className="flex flex-col md:flex-row pb-32 md:pb-0 border-b border-columbia-gray md:border-0"
          >
            <span
              data-label="intro-text-lead_in"
              className={`block mb-10 md:mb-0 font-condensed text-24 uppercase md:w-grid-1/3 flex-grow-0 ${theme.textColor}`}
              dangerouslySetInnerHTML={{ __html: intro.lead_in }}
            />{' '}
            <span
              className="text-22 leading-spacey w-full md:w-2/3 md:pl-30 text flex-shrink-0"
              dangerouslySetInnerHTML={{ __html: intro.text }}
            />
          </p>
        </div>
        {intro.images &&
          <div className="container px-25 mt-45">
            <Image images={intro.images}/>
            {
              intro.caption &&
              <p
                className="text-12 text-granite-gray pt-5"
                dangerouslySetInnerHTML={{ __html: intro.caption }}
              />
            }
          </div>
        }
      </section>
    )
  }
}

export default Intro
